module.exports = __webpack_public_path__ + "static/media/b15.e76bb7b8.png";